import React, { useContext, useEffect, useState, useRef } from 'react';
import { Context } from '../../services/contexts/StateContext';
import * as S from './styles';
import { format } from 'date-fns';
import { FiExternalLink } from 'react-icons/fi';
import api from '../../services/api';
import { ApiEvento } from '../../services/FiltrosApi/eventoApi';

import { AlertComp } from '../../componentes/alerte/index';
import { SetFunctions } from '../../componentes/Functions';
import { Add_Arquivos } from '../../componentes/Cadastro/Add_Arquivos';
import PagEventoModal from '../../componentes/Modal/PagEventoModal';
import { EventoInicialState } from '../../services/reducers/EventoReducer';

// ---Midia---
import Icon_edit from '../../midia/editar_branco.svg';
import Icon_Add from '../../midia/mais.png';
import Icon_coin from '../../midia/coin_red.svg';
import icon_pdf from '../../midia/icon_pdf.svg';
import Icon_negativa from '../../midia/cancelar.svg';


//-----------------------------------------------
const tiposEventoRef = ['Roubo', 'Colisao_part', 'Colisao_PT', 'Colisao_Incendio'];

export const DetalheEvento = (props) => {
    const { state, dispatch } = useContext(Context);
    const { evento, terceiro, guincho } = state.evento;
    const { veiculo } = state.veiculo;
    const { parametroInit, playmodal, playLista, listaPesquisa } = state.parametros;
    const { playListaPagto } = playLista;

    const [alertDelete, setAletDelete] = useState(false);
    const { AtualizarSimples, BaixarEvento, AddArquivosEvento, PesqIdEvento } = ApiEvento();
    const { SetEvento } = SetFunctions();
    const { SelectFile, AddArquivos } = Add_Arquivos();

    // -----------------------------------------
    const SetPlayLista = (key, value) => {
        dispatch({
            type: 'set_playLista',
            payload: { ...playLista, [key]: value }
        });
    };

    //-----------------------------------------
    function FecharAlerte() {
        setAletDelete(false)
    };

    //------------------------------------------
    function EditaEvento() {
        const edicaoVistoriaEvento = evento.tipoEvento === 'vistoria_evento';

        if (edicaoVistoriaEvento) {
            dispatch({
                type: 'set_Evento',
                payload: {
                    ...evento,
                    tipoEvento: '',
                    id_Fornecedor: '',
                    fornecedor: '',
                    cnpjForne: '',
                    chavePix: '',
                }
            });
            dispatch({
                type: 'set_ListaPesquisa',
                payload: {
                    ...listaPesquisa,
                    nomeItem: '',
                    listaFornecedor: [],
                }
            });
        }

        dispatch({
            type: 'SET_PLAYMODAL',
            payload: {
                ...playmodal,
                playModalEditar: true,
                playModalEven: playmodal.playModalEven ? false : true,
                playModalOrcamento: false,
                playModalDetalhesEven: false,
            }
        });

        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                editModal: true,
                detalhesLista: false,
                disabledEven: false,
                editandoVistoriaEvento: edicaoVistoriaEvento,
            }
        });
    };

    //------------------------------------------
    function NovoEventoRef() {
        const { placa, nomeCliente } = evento;
        const idRef = evento._id || evento.id_Evento;

        dispatch({ type: 'set_limparEvento' });
        dispatch({
            type: 'set_Evento',
            payload: { ...EventoInicialState.evento, placa, nomeCliente, id_EventoRef: idRef }
        });

        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                editModal: false,
                disabledEven: false,
                detalhesLista: false
            }
        });

        dispatch({
            type: 'SET_PLAYMODAL',
            payload: {
                ...playmodal,
                playModalEditar: false,
                playModalEven: true,
                playModalOrcamento: false,
                playModalDetalhesEven: false,
            }
        });
    };

    // --------------------
    function addPagamento() {
        dispatch({
            type: 'SET_PLAYMODAL',
            payload: {
                ...playmodal,
                playModalOrcamento: playmodal.playModalOrcamento ? false : true,
                playModalEven: false,
                playModalDetalhesEven: false,
            }
        });

        dispatch({
            type: 'set_playLista',
            payload: {
                ...playLista,
                playListaPagto: false
            }
        });
    };

    //-----------------------------------------------
    async function ExcluirEste(t) {
        await api.put(`evento/atualizar/${evento.id_Evento}`, {
            status: 'E'
        })
            .then(res => {
                props.PesqEventoCod();
                setAletDelete(false);
            })
    };

    // -----------------------------------
    const [ComParticip, setComPart] = useState(false);

    useEffect(() => {
        if (evento?.tipoEvento?.split("_").filter(e => e === "part").length > 0) {
            setComPart(true);
        }
    }, [evento.tipoEvento])

    // --------------------------------
    const [ListaOrdPag, setListaOrd] = useState([]);
    const [somaTotalPG, setSomaTotalPG] = useState(0);
    const [SelectValor, setSelectValor] = useState(false);
    const [editPart, seteditPart] = useState(false);
    const [editPag, seteditPag] = useState(false);
    const [mostrarHistoricoPagamentos, setMostrarHistoricoPagamentos] = useState(false);
    const [modalPagamentoAberto, setModalPagamentoAberto] = useState(false);
    const [modalNegativa, setModalNegativa] = useState(false);
    const [descricaoNegativa, setDescricaoNegativa] = useState("");

    async function SalvarNegativa() {
        if (!descricaoNegativa.trim()) {
            alert("Informe o motivo da negativa.");
            return;
        }
        await AtualizarSimples({
            negativa: true,
            descricaoNegativa: descricaoNegativa.trim(),
            status: "C",
        });
        setModalNegativa(false);
        setDescricaoNegativa("");
    }
    const eventoSelecionado = listaPesquisa.listaEvento?.[0] || {};
    const pagamentosDisponiveis = Array.isArray(listaPesquisa.listaPagamentos) && listaPesquisa.listaPagamentos.length > 0
        ? listaPesquisa.listaPagamentos
        : (Array.isArray(evento.pagamentos) && evento.pagamentos.length > 0
            ? evento.pagamentos
            : (Array.isArray(eventoSelecionado.pagamentos) ? eventoSelecionado.pagamentos : []));
    const pagamentosHistorico = pagamentosDisponiveis.length > 0
        ? pagamentosDisponiveis
        : (evento.valorPag && evento.dataPag ? [{
            data: evento.dataPag,
            tipo: evento.formaPag,
            valor: evento.valorPag,
        }] : []);
    const arquivosPagamento = (Array.isArray(evento.arquivos) ? evento.arquivos : [])
        .filter((arquivo) => /pagamento/i.test(arquivo));

    useEffect(() => {
        //-Ordenar pagamento por data-
        var xx = pagamentosHistorico.map((pagamento) => ({
            ...pagamento,
            data: pagamento.data || pagamento.dataPG,
            tipo: pagamento.tipo || pagamento.tipoPG || pagamento.formaPag,
            valor: Number(pagamento.valor ?? pagamento.valorPG ?? 0),
        })).sort((a, b) => (
            new Date(a.data || a.dataPG) - new Date(b.data || b.dataPG)
        ));
        setListaOrd(xx);

        //-Soma Total--
        const somaX = pagamentosHistorico.map(e => Number(e.valor ?? e.valorPG ?? 0));
        if (somaX.length > 0) {
            let somaTotal = 0;
            for (let i = 0; i < somaX.length; i++) {
                somaTotal += somaX[i];
            }
            setSomaTotalPG(somaTotal);
        } else {
            setSomaTotalPG(0);
        }

        //  ---------------
        listaPesquisa.listaEvento.map(t => {
            if (t.dataPart) { seteditPart(false) } else { seteditPart(true) };
            // if(t.dataPag){seteditPag(false)}else{seteditPag(true)};
        })

    }, [listaPesquisa.listaPagamentos, evento.pagamentos, evento.valorPag, evento.dataPag, evento.formaPag, listaPesquisa.listaEvento]);

    function abrirComprovante(arquivo) {
        if (!arquivo) return;
        const url = /^https?:\/\//i.test(arquivo)
            ? arquivo
            : `https://rbento-web.s3.us-east-1.amazonaws.com/${arquivo}`;
        window.open(url, '_blank', 'noopener,noreferrer');
    }

    async function abrirPagamento() {
        if (evento.status === "C") {
            seteditPag(false);
            setMostrarHistoricoPagamentos(true);
            SetPlayLista("playListaPagto", false);
            return;
        }

        await PesqIdEvento(evento.id_Evento);
        setMostrarHistoricoPagamentos(false);
        setModalPagamentoAberto(true);
    }

    // ------------------------------------
    async function AddOrcamento() {
        const orcamento = evento.orcamento.toString();

        await api.put(`/evento/atualizarSimples/${evento.id_Evento}`, {
            orcamento: parseFloat(orcamento.replace(",", "."))
        })
            .then(res => {
                alert("Sucesso!")
                setSelectValor(false);
                SetEvento("orcamento", parseFloat(orcamento.replace(",", ".")));
                PesqIdEvento(evento.id_Evento)
            })
            .catch(() => alert("erro!!!"))
    };

    // ---Click Dentro e Fora do Componente-----

    const ClickRefValor = useRef(null);
    const ClickRefPart = useRef(null);
    const ClickRefReparo = useRef(null);

    function EventoDeClick(e) {
        if (!ClickRefValor.current?.contains(e.target)) {
            setSelectValor(false);
        };
        if (!ClickRefPart.current?.contains(e.target)) {
            seteditPart(false);
        };
        if (!ClickRefReparo.current?.contains(e.target)) {
            seteditPag(false);
        };
    };

    // ------------------------------
    // useEffect(() => {
    //     document.addEventListener("click", EventoDeClick, true);

    //     return () => {
    //         document.removeEventListener("click", EventoDeClick, true);
    //     };
    // }, []);

    // ------------------------------
    useEffect(() => {
        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                disabledEven: editPag ? false : true,
            }
        });
    }, [editPag]);

    

    // ------------------------------
    const EditarModel = () => {
        dispatch({
            type: 'SET_PLAYMODAL',
            payload: {
                ...playmodal,
                playModalEvenPlaca: true,
                playModalDetalhesEven: false,

            }
        });

        dispatch({
            type: 'SET_parametroInit',
            payload: {
                ...parametroInit,
                detalhesLista: false,
            }
        });

        dispatch({
            type: 'set_ListaPesquisa',
            payload: {
                ...listaPesquisa,
                nomeItem: veiculo.placa,

            }
        });
    };

    // ------------------
    


    //###################################################################
    return (
        <>
        <S.bodyresult>
            {alertDelete &&
            <AlertComp
                alertDescrit={'Deseja mesmo Excluir?'}
                seSim={ExcluirEste}
                seNao={FecharAlerte}
            />
            }

            <S.detalhes>
                <div style={{ display: "flex", 'width': "100%", "flexDirection": "column" }}>
                    <div style={{ display: "flex", justifyContent: "space-between" }}>
                        <div style={{ display: "flex", flexDirection: "column", "width": "100%" }}>
                            <div className='listaDetalhe'>
                                <div className='lista'>
                                    <span className='titulo'>Data Evento:</span>
                                    <span>{evento?.dataEvento && format(new Date(evento?.dataEvento + 'T00:00:00'), 'dd/MM/yyyy')}</span>
                                </div>
                                <div className='lista'>
                                    <span className='titulo'>Associado:</span>
                                    <span>{evento?.nomeCliente}</span>
                                    <span>Celular</span>
                                </div>
                                <div className='lista'>
                                    <span className='titulo'>Evento: </span>
                                    <span>{evento.tipoEvento === "PT" ? "Perca Total" : evento.tipoEvento}</span>
                                    <span className='titulo' style={{ textTransform: "uppercase" }}>BO: </span>
                                    <span>{evento?.ocorrenciaBO}</span>

                                </div>
                            </div>

                            <div className='listaDetalhe' style={{ marginTop: "5px" }}>
                                <div className='lista'>
                                    <span className='titulo'>Veiculo: </span>
                                    <span
                                        style={{ cursor: "pointer", color: "yellow" }}
                                        onClick={() => EditarModel()}>
                                        {evento?.placa}
                                    </span>
                                    <span>
                                        {veiculo?.modelo}
                                    </span>
                                </div>
                                <div className='lista'>
                                    <span className='titulo'>Valor Fipe: </span>
                                </div>

                                <div className='lista'>
                                    <span className='titulo'>Terceiro:</span>
                                    <span style={{ textTransform: "uppercase" }}>{terceiro?.placa}</span>
                                    <span style={{ textTransform: "uppercase" }}>{terceiro?.modelo}</span>
                                    <span>{parseFloat(terceiro?.valorFipe).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                                </div>

                                <div className='lista'>
                                    <span className='titulo'>Total R$:</span>
                                    <span style={{ color: "orange", cursor: "pointer" }} onClick={() => seteditPag(true)}>
                                        {parseFloat(evento?.orcamento).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                    </span>
                                    <span className='titulo'>Pendente R$:</span>
                                    <span style={{ color: "red" }}>
                                        {Math.max(Number(evento?.orcamento || 0) - somaTotalPG, 0).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                    </span>
                                </div>
                            </div>

                            <div className='listaDetalhe' style={{ marginTop: "5px" }}>
                                <div className='lista'>
                                    <span className='titulo'>Fornecedor: </span>
                                    <span>{evento?.fornecedor}</span>
                                </div>
                                <div className='lista'>
                                    <span className='titulo'>Cadastro: </span>
                                    <span>{evento?.userCadastro}</span>
                                </div>
                            </div>

                            <div className='lista'>
                                <span className='titulo'>Descrição:</span>
                                <span style={{ display: "flex", textTransform: "lowercase", maxWidth: "400px", wordBreak: "break-all" }}>{evento?.descricao}</span>
                            </div>
                        </div>
                        
                        {/* ICONS ------------- */}
                        <div style={{ display: 'flex', 'flexDirection': "column", justifyContent: "space-around" }}>
                            <img
                            className='icone'
                            src={Icon_edit}
                            onClick={() => EditaEvento()}
                            alt="icone"
                            />

                            {tiposEventoRef.includes(evento.tipoEvento) &&
                            <img
                            style={{ width: "20px", height: "20px" }}
                            className='icone'
                            src={Icon_Add}
                            title="Novo evento vinculado"
                            onClick={NovoEventoRef}
                            alt="icone"
                            />
                            }

                            <img
                            style={{ width: "20px", height: "20px" }}
                            className='icone'
                            src={Icon_coin}
                            onClick={abrirPagamento}
                            alt="icone"
                            />

                            <img
                            style={{ width: "22px", height: "22px" }}
                            className='icone'
                            src={Icon_negativa}
                            title="Negativa"
                            onClick={() => setModalNegativa(true)}
                            alt="icone"
                            />

                            {evento.status === "C" &&
                            <img
                            style={{ width: "25px"}}
                            className='icone'
                            src={icon_pdf}
                            onClick={() => { SelectFile()}}
                            alt="icone"
                            />
                            }

                        </div>
                    </div>

                    {/* ------------- GUINCHO ------------- */}
                    {guincho.origem &&
                    <div style={{ display: "flex", flex: "1", borderTop: "1px solid #3881ff"  }}>
                        <div className='lista' style={{ minWidth: "120px" }}>
                            <span className='titulo'>Origem:</span>
                            <span>{guincho.origem}</span>
                        </div>
                        <div className='lista' style={{ minWidth: "120px" }}>
                            <span className='titulo'>Destino:</span>
                            <span>{guincho.destino}</span>
                        </div>
                        <div className='lista' style={{ minWidth: "80px" }}>
                            <span className='titulo'>KM:</span>
                            <span>{guincho.km}</span>
                        </div>
                    </div>
                    }

                    {/*----PARTICIPAÇÃO------*/}
                    {ComParticip && 
                    <>
                    <div style={{ borderBottom: "1px solid #3881ff" }} />
                    <div ref={ClickRefPart} style={{ display: "flex", "alignItems": "end", padding: "5px 0" }}>
                        {!evento.valorPart || editPart ?
                        <>
                            <div className='lista'>
                                <span className='titulo'>Data Participação: </span>
                                <input
                                    type="date"
                                    placeholder='Data Participação'
                                    value={evento.dataPart ? format(new Date(evento.dataPart + "T00:00:00-03:00"), 'yyyy-MM-dd') : ""}
                                    onChange={e => SetEvento('dataPart', e.target.value)}
                                />
                            </div>
                            <div className='lista'>
                                <span className='titulo'>Valor Participação: </span>
                                <input
                                    type="number"
                                    placeholder='valor'
                                    value={evento.valorPart}
                                    onChange={e => SetEvento('valorPart', e.target.value)}
                                />
                            </div>
                            <div className='lista'>
                                <span className='titulo'>Observação: </span>
                                <input
                                    type="text"
                                    placeholder='detalhes'
                                    value={evento.detalhePart}
                                    onChange={e => SetEvento('detalhePart', e.target.value)}
                                />
                            </div>
                        </>
                        
                        :

                        <div style={{ display: "flex", flex: "1" }}>
                            <div className='lista'>
                                <span className='titulo'>Data Participação: </span>
                                <span>{evento.dataPart ? format(new Date(evento?.dataPart), 'dd/MM/yyyy') : ""}</span>
                            </div>
                            <div className='lista'>
                                <span className='titulo'>Valor Participação: </span>
                                <span>{parseFloat(evento?.valorPart).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                            </div>
                            <div className='lista'>
                                <span className='titulo'>Observação: </span>
                                <span>{evento.detalhePart}</span>
                            </div>
                        </div>
                        }

                        {editPart ?
                            <button
                                type='button'
                                onClick={() => AtualizarSimples()}>add
                            </button>
                            :
                            <img
                                className='icone'
                                src={Icon_edit}
                                onClick={() => seteditPart(true)}
                                alt="icone"
                            />
                        }
                    </div>
                    </>}

                    {/* -----PAGAMENTO-------- */}
                    {(evento.dataPart || editPag) && !mostrarHistoricoPagamentos &&
                    <div ref={ClickRefReparo} style={{ display: "flex", "alignItems": "end", borderTop: "1px solid #3881ff", marginBottom: "5px" }}>
                        {(!evento.valorPag || editPag) ?
                            <>
                                <div className='lista'>
                                    <span className='titulo'>Data Ressarcimento: </span>
                                    <input
                                    type="date"
                                    placeholder='Data Participação'
                                    value={evento.dataPag}
                                    onChange={e => SetEvento('dataPag', e.target.value)}
                                    />
                                </div>

                                <div className='lista'>
                                    <span className='titulo'>Ressarcimento: </span>
                                    <span>
                                        {parseFloat(evento?.valorPart? evento?.orcamento - evento?.valorPart : evento?.orcamento).toLocaleString('pt-br', { style: 'currency', currency: 'BRL'})}
                                    </span>
                                </div>

                                <div className='lista'>
                                    <span className='titulo'>Forma Pagamento: </span>
                                    <select
                                    value={evento.formaPag || ''}
                                    onChange={e => SetEvento('formaPag', e.target.value)}
                                    >
                                        <option value="">Selecione...</option>
                                        <option value="Pix">Pix</option>
                                        <option value="Boleto">Boleto</option>
                                    </select>
                                </div>

                                <div>
                                    <img
                                    src={icon_pdf}
                                    onClick={() => { SelectFile(); seteditPag(true) }}
                                    style={{ width: "25px", cursor: "pointer" }}
                                    />
                                </div>
                            </>
                            :
                            <>
                                <div className='lista'>
                                    <span className='titulo'>Data Pagamento: </span>
                                    <span>{evento.dataPag && format(new Date(evento.dataPag + 'T00:00:00'), 'dd/MM/yyyy')}</span>
                                </div>
                                <div className='lista'>
                                    <span className='titulo'>Valor Pago: </span>
                                    <span>{parseFloat(evento?.valorPag).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                                </div>
                                <div className='lista'>
                                    <span className='titulo'>Forma Pagamento: </span>
                                    <span>{evento.formaPag}</span>
                                </div>
                            </>
                        }

                        {(!evento.valorPag || editPag) ?
                            <button
                            type='button'
                            onClick={() => BaixarEvento(seteditPag)}>add
                            </button>
                            :
                            <img
                            className='icone'
                            src={Icon_edit}
                            onClick={() => seteditPag(true)}
                            alt="icone"
                            />
                        }
                    </div>
                    }

                    {/* ---------COLISAO ORÇAMENTO----------- */}
                    {evento.tipoEvento === "Colisao_part" && !mostrarHistoricoPagamentos &&
                    <S.ListaPag>
                        <div style={{ display: "flex", justifyContent: "space-between", color: "#00D594", width: "100%", padding: "5px 0" }}>
                            <div ref={ClickRefValor} style={{ display: "flex", flexDirection: "row" }}>
                                <span>Orçamento:</span>
                                {SelectValor ?
                                    <>
                                        <input
                                            style={{ backgroundColor: "#30353F", borderRadius: "3px", marginLeft: "5px" }}
                                            type="text"
                                            autoFocus
                                            value={evento.orcamento}
                                            onChange={(e) => SetEvento("orcamento", e.target.value)}
                                        />

                                        <button
                                            style={{ marginLeft: "5px" }}
                                            onClick={() => AddOrcamento()}
                                        >
                                            add
                                        </button>
                                    </>
                                    :
                                    <span
                                        className='botaoTotal'
                                        style={{ color: "yellow" }}
                                        onClick={() => setSelectValor(true)}
                                    >
                                        {parseFloat(evento.orcamento).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                    </span>
                                }
                            </div>

                            <span>Pago:
                                <span
                                    className='botaoTotal'
                                    style={{ color: "orange" }}
                                    onClick={() => SetPlayLista("playListaPagto", playListaPagto ? false : true)}
                                >
                                    {parseFloat(somaTotalPG).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                </span>
                            </span>

                            <span>Pendente:
                                <span style={{ color: "red", marginLeft: "3px" }}>
                                    {parseFloat(evento.orcamento - somaTotalPG).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}
                                </span>
                            </span>
                        </div>
                        {playLista.playListaPagto &&
                            <div style={{ display: "flex", width: "100%", flexDirection: "column", maxHeight: "150px", overflow: "auto" }}>
                                {ListaOrdPag.map((p, k) => (
                                    <div className='listaPg' key={k}>
                                        <span style={{ paddingLeft: "3px" }}>{p.data ? format(new Date(p.data), 'dd/MM/yyyy') : ""}</span>
                                        <span>{p.tipo}</span>
                                        <span>{parseFloat(p.valor).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })}</span>
                                    </div>
                                ))}
                            </div>}
                    </S.ListaPag>
                    }

                    {mostrarHistoricoPagamentos &&
                    <S.ListaPag>
                        <span className='titulo'>Histórico de pagamentos:</span>
                        {pagamentosHistorico.length > 0 ? pagamentosHistorico.map((pagamento, indice) => {
                            const dataPagamento = pagamento.data || pagamento.dataPG;
                            const tipoPagamento = pagamento.tipo || pagamento.tipoPG || pagamento.formaPag;
                            const valorPagamento = Number(pagamento.valor ?? pagamento.valorPG ?? 0);

                            return (
                            <div className='listaPg' key={`${dataPagamento || 'pagamento'}-${indice}`}>
                                <span>{dataPagamento ? format(new Date(dataPagamento), 'dd/MM/yyyy') : 'Sem data'}</span>
                                <span>{tipoPagamento || 'Pagamento'}</span>
                                <span>{valorPagamento.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                {(pagamento.arquivo || pagamento.comprovante || pagamento.arquivos?.[0] || arquivosPagamento[indice]) && (
                                    <button
                                        type='button'
                                        title='Abrir comprovante'
                                        aria-label='Abrir comprovante'
                                        onClick={() => abrirComprovante(pagamento.arquivo || pagamento.comprovante || pagamento.arquivos?.[0] || arquivosPagamento[indice])}
                                    >
                                        <FiExternalLink size={16} />
                                    </button>
                                )}
                            </div>
                            );
                        }) : <span>Nenhum pagamento registrado.</span>}
                    </S.ListaPag>
                    }
                    
                    {/* Imagens--------- */}
                    <S.boxFiles
                    Files={listaPesquisa.listaArquivos.length > 0 || evento.arquivos.length > 0}
                    >
                        <div style={{display:"flex", width:"100%", flexDirection:"column"}}>
                            <AddArquivos />

                            {evento.status === "C" && listaPesquisa.listaArquivos.length > 0 &&
                            <div style={{display:"flex", width:"100%", justifyContent:"center"}}>
                                <button
                                type='button'
                                onClick={() => AddArquivosEvento()}
                                >add
                                </button>
                            </div>
                            }
                        </div>
                    </S.boxFiles>
                </div>

            </S.detalhes>
        </S.bodyresult>
        {modalNegativa &&
        <div
            style={{ position: "fixed", inset: 0, background: "rgba(0,0,0,0.6)", display: "flex", alignItems: "center", justifyContent: "center", zIndex: 1000 }}
            onClick={() => setModalNegativa(false)}
        >
            <div
                style={{ background: "#fff", color: "#000", padding: "20px", borderRadius: "8px", width: "90%", maxWidth: "420px", display: "flex", flexDirection: "column", gap: "10px" }}
                onClick={(e) => e.stopPropagation()}
            >
                <strong>Negativa</strong>
                <textarea
                    rows={5}
                    placeholder="Descreva o motivo da negativa"
                    value={descricaoNegativa}
                    onChange={(e) => setDescricaoNegativa(e.target.value)}
                    style={{ width: "100%", resize: "vertical" }}
                />
                <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
                    <button type='button' onClick={() => setModalNegativa(false)}>Cancelar</button>
                    <button type='button' onClick={SalvarNegativa}>Salvar</button>
                </div>
            </div>
        </div>
        }
        <PagEventoModal
            aberto={modalPagamentoAberto}
            onFechar={() => setModalPagamentoAberto(false)}
            evento={evento}
            pagamentos={listaPesquisa.listaPagamentos}
            temArquivosNovos={listaPesquisa.listaArquivos.length > 0}
            anexos={<AddArquivos permitirExcluirArquivosSalvos={false} />}
            aoAlterarEvento={SetEvento}
            aoSelecionarArquivo={SelectFile}
            aoSalvarPagamento={(valor, descricao) => BaixarEvento(null, valor, descricao)}
            aoPagamentoConfirmado={() => PesqIdEvento(evento.id_Evento, true)}
        />
        </>

    )
}